import React from 'react';
import './_import-options.scss';
import './_import-options.dark-mode.scss'
import classNames from 'classnames';
import PropTypes from 'prop-types';
import OptionItem from './Item';
import FormSwitch from '../../../../../../../../../components/FormSwitch';
import * as importTypes from '../../../reducer/constants';

const Options = ({ options, dispatchImportState }) => {
  const isCheckedCopyDescription = !!options?.support_copy_descriptions;

  const onChangeCopyDescription = () => {
    const value = !isCheckedCopyDescription;
    dispatchImportState({ type: importTypes.IMPORT_CHANGE_DESCRIPTION, value });
  }

  return (
    <div className={classNames('services-import__options')}>
      <OptionItem>
        <FormSwitch
          id="option-description"
          name="option-description"
          checked={isCheckedCopyDescription}
          onChange={onChangeCopyDescription}
        >
          Copy descriptions
        </FormSwitch>
      </OptionItem>
    </div>
  )
}

Options.propTypes = {
  options: PropTypes.object,
  dispatchImportState: PropTypes.func,
};
export default Options;
